import { render, staticRenderFns } from "./ActionsButton.vue?vue&type=template&id=b0f65b56&scoped=true"
import script from "./ActionsButton.vue?vue&type=script&lang=js"
export * from "./ActionsButton.vue?vue&type=script&lang=js"
import style0 from "./ActionsButton.vue?vue&type=style&index=0&id=b0f65b56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f65b56",
  null
  
)

export default component.exports